import styled from '@emotion/styled';
import React from 'react';

const Stylescal = styled.div`
  .checkbox-wrapper-31 {
    position: relative;
    display: inline-block;
    width: 35px;
    height: 35px;
    cursor: pointer;
  }

  .checkbox-wrapper-31 .background {
    fill: #ccc;
    transition: all 0.6s ease;
  }

  .checkbox-wrapper-31 .stroke {
    fill: none;
    stroke: #fff;
    stroke-miterlimit: 10;
    stroke-width: 2px;
    stroke-dashoffset: 100;
    stroke-dasharray: 100;
    transition: all 0.6s ease;
  }

  .checkbox-wrapper-31 .cross {
    fill: none;
    stroke: #fff;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2px;
    stroke-dashoffset: 0;
    stroke-dasharray: 100;
    transition: all 0.6s ease;
  }

  .checkbox-wrapper-31 input[type='checkbox'] {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    margin: 0;
    opacity: 0;
    appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
  }

  // .checkbox-wrapper-31 input[type='checkbox']:hover + svg .background {
  //   fill: #f1f1f1; /* Background color on hover */
  // }

  // .checkbox-wrapper-31 input[type='checkbox']:hover + svg .stroke {
  //   stroke: #ccc; /* Circle border color on hover */
  // }

  // .checkbox-wrapper-31 input[type='checkbox']:hover + svg .cross {
  //   stroke: #ccc; /* Cross color on hover */
  // }

  .checkbox-wrapper-31 input[type='checkbox']:checked + svg .background {
    fill: #e74c3c; /* Circle background color when checked */
  }

  .checkbox-wrapper-31 input[type='checkbox']:checked + svg .stroke {
    stroke-dashoffset: 0;
  }

  .checkbox-wrapper-31 input[type='checkbox']:checked + svg .cross {
    stroke-dashoffset: 0;
    stroke: #fff; /* X color when checked */
  }

  .checkbox-wrapper-31 input[type='checkbox']:checked + svg .stroke {
    stroke: #fff; /* Circle border color when checked */
  }
`;

/**
 * @type { React.ForwardRefExoticComponent<React.InputHTMLAttributes<HTMLInputElement> & React.RefAttributes<HTMLInputElement>>}
 */

const CustomWrong = React.forwardRef((props, ref) => {
  return (
    <>
      <Stylescal>
        <div class="checkbox-wrapper-31">
          <input {...props} type="checkbox" ref={ref} />
          <svg viewBox="0 0 35.6 35.6">
            <circle class="background" cx="17.8" cy="17.8" r="17.8"></circle>
            <circle class="stroke" cx="17.8" cy="17.8" r="14.37"></circle>
            <line class="cross" x1="11" y1="11" x2="24" y2="24"></line>
            <line class="cross" x1="24" y1="11" x2="11" y2="24"></line>
          </svg>
        </div>
      </Stylescal>
    </>
  );
});

export default CustomWrong;
